import React from 'react';
import { Text, View } from '@coinscrap/webapp-core';

import { getCurrency } from 'helpers/currency';
import * as S from './styles';

export const PackagesValueCard = ({ index, coverage, pack, isMobile }) => {
	const title = index === 0 ? 'Básico' : index === 1 ? 'Óptimo' : 'Extra';
	let value =
		pack?.capitalList?.item.length > 0
			? pack?.capitalList?.item.find((co) => co.description === coverage.description)?.value
			: pack?.coverageList?.capitalList.item.length > 0
				? pack?.coverageList?.capitalList.item.find(
					(co) => co.description === coverage.description,
				)?.value
				: '';
	if (value.includes('€')) {
		value = value.replace('€', '');
	}
	if (value.includes(',')) {
		value = value.replace('.', '');
		value = value.replace(',', '.');
		value = value / 1000;
	}
	const displayValue =
		value === 'N' ? (
			''
		) : value === 'S' ? (
			<>&#10003;</>
		) : !value ? (
			''
		) : value.includes('.') ? (
			getCurrency(value * 1000, 0)
		) : (
			getCurrency(value, 0)
		);

	return (
		<>
			{isMobile ? (
				<View rowSt justifyBetweenSt>
					<Text packCellMobileTitleSt>{title}</Text>
					<Text packCellMobileValueSt>{displayValue}</Text>
				</View>
			) : (
				<S.PackCell packCellSt rowSt>
					<Text packCellSt>{displayValue}</Text>
				</S.PackCell>
			)}
		</>
	);
};
